export enum ActionResult {
  FAIL = 'fail',
  SUCCESS = 'success',
}
